import qs from 'query-string';

import { entityTypeToApiType } from 'helpers/mapEntityTypes';
import { EntityTypes, SalesTypes } from 'context/entityContext';
import getCountryIds from 'helpers/getCountryIds';

import { sortOrderTypes } from 'types/shared';

interface IBrowseEntityUrlArgs {
  entityType: EntityTypes;
  browseEntityType: string;
  entityIds: string[];
  salesType?: SalesTypes;
  customerFilter?: number[];
  mediaTypes?: string;
  sortOrder?: sortOrderTypes;
  sortby?: string;
  secondarySortby?: string;
  countryIds?: string;
  limit?: number;
  offset?: number;
  nameFilter?: string;
  showGrouped?: boolean;
  region?: string;
  releaseType?: string;
  customRegion?: string | string[];
}

export default function getBrowseEntityUrl(args: IBrowseEntityUrlArgs): string {
  const {
    entityType,
    browseEntityType,
    entityIds,
    salesType,
    customerFilter,
    mediaTypes,
    sortOrder,
    sortby,
    secondarySortby,
    countryIds,
    limit,
    offset,
    nameFilter,
    showGrouped = true,
    region,
    releaseType,
    customRegion,
  } = args;

  const type = entityTypeToApiType(entityType);
  const params = qs.stringify({
    salesType,
    customerFilter,
    mediaTypes,
    sortOrder,
    sortby,
    countryIds: getCountryIds(countryIds, region, customRegion),
    limit,
    offset,
    nameFilter,
    showGrouped,
    releaseType,
    secondarySortby:
      browseEntityType !== 'labels' ? (secondarySortby || 'performance_last_week') : undefined,
    secondarySortOrder: 'desc',
  });

  return `/api/browse/${type}/${entityIds}/${browseEntityType}?${params}`;
}
